import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { Grid, makeStyles } from '@material-ui/core';
import Order from '../../Order/Order';
import React, { useEffect, useState } from 'react';
import BackForwardButton from '../../Shared/BackForwardButton';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import clsx from 'clsx';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { productionOrderStates as state } from '../../../Config/productionOrderStates'
import { xsValue,closeFinishRushOrderDialogTimeout } from '../../../Config/constants'
import VisitorRegistrationDialog from '../../Shared/Dialogs/VisitorRegistrationDialog';
import { connect } from 'react-redux';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';

export const OrderOverviewPage = (props) => {

    const { t } = useTranslation();
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [noOrdersFound, setNoOrdersFound] = useState(false);
    const [timer, setTimer] = React.useState(null);
    const [searchString, setSearchString] = useState("");
    const [productionOrders, setProductionOrders] = useState([]);
    const [visitorRegistrationDialogOpen, setVisitorRegistrationDialogOpen] = useState(false);
    const [finishRushOrderDialog, setFinishRushOrderDialogOpen] = useState(false)
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [refresh, setRefresh] = useState(false)

    useEffect(() => {
        let mounted = true
        clearInterval(timer)
        setTimer(null)
        if (mounted) {
            //refresh orders every 15 minutes
            let elapsedTimer = setInterval(() => refreshOrders(), 900000);
            setTimer(elapsedTimer)
        }
        if (searchString) {
            dataService.getProductionOrdersBySearchText(searchString).then(orders => {
                if (!orders) {
                    setNoOrdersFound(true)
                }
                else {
                    setNoOrdersFound(false)
                    if (mounted) {
                        if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                            setProductionOrders(orders)
                        }
                    }
                }

            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
        else {
            setNoOrdersFound(false)
            dataService.getProductionOrdersByMachine(1).then(orders => {
                if (mounted) {
                    if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {

                        setProductionOrders(orders)
                    }
                }
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }

        return function cleanup() {
            mounted = false
        }
    }, [searchString, refresh]);

    useEffect(() => {
        if (props.order.refreshOrders) {
            setRefresh(!refresh)
            props.actions.refreshOrders(false)
        }
    }, [props.order.refreshOrders])

    useEffect(() => {
        if(productionOrders.length > 0){
            setRefresh(!refresh)
            var orderReferenceString = ""
            for (var orderId of props.order.finishedOrderIds) {
                var order = productionOrders.find(x => x.id === orderId)
                if(JSON.parse(order.metaData).find(x => x.MetaDataType === 1).MetaData[0].RushOrder){
                    if(orderReferenceString === ""){
                        orderReferenceString += order.reference 
                    }
                    else{
                        orderReferenceString += " & " + order.reference
                    }
                }            
            }
    
            if(orderReferenceString !== ""){
                setDialogTitle("Order finished!")
                setDialogContext("Flashlight is ready for rush order(s): " + orderReferenceString)
                setFinishRushOrderDialogOpen(true)
                setTimeout(() => setFinishRushOrderDialogOpen(false), closeFinishRushOrderDialogTimeout)
            }    
        }
        
    }, [props.order.finishedOrderIds])

    let activeProductionOrders = <React.Fragment></React.Fragment>
    let doneProductionOrders = <React.Fragment></React.Fragment>


    if (productionOrders) {

        activeProductionOrders = productionOrders.filter(x => x.productionOrderStatus !== state.DONE && x.productionOrderStatus !== state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
        doneProductionOrders = productionOrders.filter(x => x.productionOrderStatus === state.DONE || x.productionOrderStatus === state.STOPPED).sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
    }
    if (searchString && !noOrdersFound) {
        activeProductionOrders = productionOrders.sort((a, b) => new Date(b.startedOn) - new Date(a.startedOn)).map((order) => (<Grid item key={order.id} className={classes.gridmargin} xs={xsValue}><Order key={order.id} actions={props.actions} productionOrder={order} {...props}></Order></Grid>));
        doneProductionOrders = activeProductionOrders
    }
    if (noOrdersFound) {
        doneProductionOrders = <div className={classes.noOrdersFound}>{t("No orders found for the search criteria entered")}</div>
        activeProductionOrders = doneProductionOrders
    }


    function searchOrder(e) {
        setSearchString(e.target.value)
    }

    const rushOrder = () => {
        setDialogTitle('Visitor registration')
        setDialogContext('Please fill in your details')
        setVisitorRegistrationDialogOpen(true)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        {children}
                    </Box>
                )}
            </div>
        );
    }

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const saveVisitor = () => {
        setVisitorRegistrationDialogOpen(false)
    }

    function refreshOrders() {
        dataService.getProductionOrdersByMachine(1).then(orders => {
            if (JSON.stringify(orders) !== JSON.stringify(productionOrders)) {
                setProductionOrders(orders)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    const closeFinishRushOrderDialog = () => {
        setFinishRushOrderDialogOpen(false)
    }

    let newDate = new Date();
    let day = newDate.getDate();
    let month = newDate.toLocaleString('default', { month: 'long' })
    let monthUppercase = month.charAt(0).toUpperCase() + month.substring(1, month.length);
    let year = newDate.getFullYear();
    let date = monthUppercase + " " + day + "th " + year;

    return <div className={classes.backGround}>
        <div className={classes.spacer80}>
            <div className={classes.left}>
                <NavLink className={classes.navButton} to={"/"}>
                    <BackForwardButton direction={"back"}></BackForwardButton>
                </NavLink>
                <div className={classes.date}>{date} {'DayPlanning'}</div>
                <div className={classes.title}>{'Production queue'}</div>
            </div>
            <div className={classes.right}>
                <div className={classes.searchContainer}>
                    <TextField
                        className={classes.search}
                        id="input-with-icon-textfield"
                        variant="outlined"
                        size="small"
                        onChange={(e) => searchOrder(e)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <img className={classes.eye} src={process.env.PUBLIC_URL + '/img/search.svg'} alt={""}></img>
                                </InputAdornment>
                            ),
                        }}>
                    </TextField>
                    <button className={classes.rushButton} onClick={() => rushOrder()}>
                        <div className={classes.refreshText}>{"RUSH ORDER"}</div>
                    </button>
                </div>
            </div>
        </div>
        <AppBar position="static" className={classes.appBar}>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label="ACTIVE" {...a11yProps(0)} className={clsx({ [classes.activeTab]: value === 0, [classes.notActiveTab]: value !== 0 })} />
                <Tab label="DONE" {...a11yProps(1)} className={clsx({ [classes.activeTab]: value === 1, [classes.notActiveTab]: value !== 1 })} />
            </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
            <Grid container spacing={3} className={classes.grid}>
                {activeProductionOrders}
            </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
            <Grid container spacing={3} className={classes.grid}>
                {doneProductionOrders}
            </Grid>
        </TabPanel>
        <AlertDialog dialogOpen={finishRushOrderDialog} closeDialog={closeFinishRushOrderDialog} dialogContext={dialogContext} dialogTitle={dialogTitle} action ={closeFinishRushOrderDialog}></AlertDialog>
        <VisitorRegistrationDialog {...props} dialogOpen={visitorRegistrationDialogOpen} closeDialog={() => setVisitorRegistrationDialogOpen(false)} dialogTitle={dialogTitle} dialogContext={dialogContext}></VisitorRegistrationDialog>
    </div>
}

const useStyles = makeStyles({
    spacer80: {
        height: '80px'
    },
    backGround: {
        paddingRight: "1%",
        paddingTop: "20px",
        position: "relative",
        top: "40px"
    },

    gridmargin: {
        minWidth: "450px",
        height: "155px",
        paddingBottom: "1.5% !important",
        paddingRight: "0.8% !important",
        marginBottom: "1.5% !important",
        boxSizing: 'border-box'
    },
    navButton: {
        textDecoration: "none"
    },
    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        paddingLeft: "5px",
        marginLeft: "20px"
    },
    date: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#8D8D8D",
        marginTop: "4px",
        paddingLeft: "7px",
        marginBottom: "3px",
        marginLeft: "20px"
    },

    search: {
        backgroundColor: "white",
        top: "5px",
        right: "30px"
    },
    left: {
        width: "50%",
        height: "90px",
        float: 'left'
    },
    right: {
        width: "50%",
        height: "90px",
        float: 'left'
    },
    appBar: {
        backgroundColor: "rgba(1,1,1,0)",
        boxShadow: "none",
        color: "#020100",
        "& > div > div > span": {
            backgroundColor: FlagstoneTheme.palette.primary.main,
            height: "3px",
            width: "80px !important"

        },
        borderBottom: "1px solid #e3e0de",
        marginLeft: "30px",
        width: "97%",
        overflow: "visible"

    },
    activeTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: FlagstoneTheme.palette.primary.main,
        fontWeight: 'bold',
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    notActiveTab: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        paddingBottom: "0px",
        minWidth: "80px !important"
    },
    rushButton: {
        width: "130px",
        height: "40px",
        border: "none",
        outline: "none",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        borderRadius: "5px",
        marginTop: "15px",
        cursor: "pointer",
        zIndex: "999",
        position: "relative",
        right: "30px",
        float: "right",
        paddingLeft: "15px",
        paddingBottom: "5px"
    },
    searchContainer: {
        width: "200px",
        float: "right",
        height: "90px"

    },
    refreshText: {
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        color: "white",
        float: "left",
        paddingTop: "3px",
        cursor: "pointer"

    },

});

function mapStateToProps(state) {
    return {
        order: state.order
    }
}

export default connect(mapStateToProps)(OrderOverviewPage)